import { useStore as e } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
import { ESequenceUpdateType as r } from "@magnopus-opensource/connected-spaces-platform-web-api";
//#region src/lib/stores/hotspot-groups-store/useHotspotGroupsStore.ts
var i = void 0, a = async (e) => {
	if (i) {
		let t = await i.hotspotGroups.getHotspotGroup(e), n = l.getState().hotspotGroups, r = n.findIndex((t) => t.name === e);
		r >= 0 ? (console.warn(`Create sequence event received for an already known hotspot group ${e}`), n[r] = t, l.setState({ hotspotGroups: [...n] })) : l.setState({ hotspotGroups: [...n, t] });
	} else console.warn("Hotspot group created event received without an active client");
}, o = async (e, t) => {
	if (i) {
		let n = t || e, r = await i.hotspotGroups.getHotspotGroup(n), a = l.getState().hotspotGroups, o = a.findIndex((t) => t.name === e);
		o >= 0 && (a[o] = {
			name: n,
			hotspots: r.hotspots
		}, l.setState({ hotspotGroups: [...a] }));
	} else console.warn("Hotspot group updated event received without an active client");
}, s = async (e) => {
	if (i) {
		let t = l.getState().hotspotGroups, n = t.findIndex((t) => t.name === e);
		n >= 0 && (t.splice(n, 1), l.setState({ hotspotGroups: [...t] }));
	} else console.warn("Hotspot group deleted event received without an active client");
}, c = async ({ type: e, name: t, newName: n }) => {
	switch (e) {
		case r.Create:
			a(t);
			break;
		case r.Update:
			o(t, n);
			break;
		case r.Delete:
			s(t);
			break;
	}
}, l = t((e, t) => ({
	hotspotGroups: [],
	initialised: !1,
	initialise: async (t) => {
		t ? i === void 0 ? (t.internalEvents.once("space-entity-load-complete", async () => {
			t.hotspotGroups.connect(), e({
				initialised: !0,
				hotspotGroups: await t.hotspotGroups.getHotspotGroupsForSpace()
			}), t.internalEvents.on("hotspot-sequence-changed", c);
		}), i = t) : console.warn("Multiple initialisations of the hotspot group store") : console.warn("Initialisation of the hotspot group store attempted without a valid Olympus client ");
	},
	uninitialise: (t) => {
		i ? (i !== t && console.warn("Wrong Olympus client passed to uninitialise, correct instance used"), i.internalEvents.off("hotspot-sequence-changed", c), i = void 0, e({
			hotspotGroups: [],
			initialised: !1
		})) : console.warn("uninitialise called when hotspot group store not initialised");
	},
	renameGroup: async (n, r) => {
		if (i) {
			let a = t().hotspotGroups, o = a.find((e) => e.name === n.name);
			if (o) {
				let t = i.hotspotGroups.renameHotspotGroup(n, r);
				return o.name = r, e({ hotspotGroups: [...a] }), t;
			} else throw Error(`renameGroup - group ${n.name} not found`);
		} else throw Error("renameGroup called when hotspot group store not initialised");
	},
	deleteGroup: async (n) => {
		if (i) {
			let r = t().hotspotGroups, a = r.findIndex((e) => e.name === n.name);
			if (a < 0) throw Error("Group name does not exist");
			return r.splice(a, 1), e({ hotspotGroups: [...r] }), i.hotspotGroups.deleteHotspotGroup(n);
		} else throw Error("deleteGroup called when hotspot group store not initialised");
	},
	createGroup: async (n, r) => {
		if (i) {
			let a = t().hotspotGroups;
			if (a.find((e) => e.name === n)) throw Error("Group name already exists");
			let o = await i.hotspotGroups.createHotspotGroup(n, r);
			return e({ hotspotGroups: [...a, o] }), o;
		} else throw Error("createGroup called when hotspot group store not initialised");
	},
	updateGroup: async (n, r) => {
		if (i) {
			let a = t().hotspotGroups, o = a.findIndex((e) => e.name === n.name);
			if (o < 0) throw Error("Group name does not exist");
			let s = await i.hotspotGroups.updateHotspotGroup(n, r);
			return a[o] = s, e({ hotspotGroups: [...a] }), s;
		} else throw Error("updateGroup called when hotspot group store not initialised");
	},
	updateAvailableHotspotIds: (e) => {
		let n = t().hotspotGroups;
		for (let r of n) {
			let n = r.hotspots.filter((t) => e.has(t));
			(n.length !== r.hotspots.length || n.some((e) => !r.hotspots.includes(e))) && t().updateGroup(r, n);
		}
	},
	reset: () => {
		e({ hotspotGroups: [] });
	}
})), u = (t) => e(l, n(t));
//#endregion
export { l as hotspotGroupsStore, u as useHotspotGroupsStore };
